module.exports = __webpack_public_path__ + "static/sys_ph03-425793fb31c9ae744c73d8b616c89831.jpg";